export default "__VITE_ASSET__eWr$a$gW__"